<template>
    <div>    
        <div><input type="checkbox" @change="checkAll" class="all-check" />&nbsp;{{ getTranslation('b056') }}</div>
        <Tree :key="selectionVersion" :data="macData" :render="renderMacContent" class="tree-render" empty-text="">
        </Tree>      
    </div>
</template>
<script>
import { Tree } from 'view-design';
import { mapGetters } from 'vuex'

export default {
    name: 'ProductlineEdit', // 组件名称
    components: {
        Tree,
        },
    props: {
        macData: Array,
    },
    data() {
        return {
            selectionVersion: 1,
            allCheck: false,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
    },
    watch: {
    },
    created() {
    },
    methods: {
        renderMacContent(h, { node, data }) {
            // icon (arrow for line or status dot for machine)
            var title = data.name;
            // checkbox for both product line and machine

            let checkboxVNode = h('input', {
                key: `cb-p-${data.id}`,
                attrs: { type: 'checkbox' ,id: 'cb-p-'+data.id},
                domProps: { checked: data.selected },
                style: { marginRight: '0px', cursor: 'pointer', width: '16px', height: '16px' },
                on: {
                    change: (e) => {                        
                        this.onMacNodeCheckboxChange(data, e.target.checked);
                    },
                    click: (e) => {                        
                        e.stopPropagation()
                    }
                }
            });
            let Label = h('label', {
                style: { display:'inline-block',paddingRight:'4px' },
                attrs: { for: 'cb-p-'+data.id },
                on: {
                    click: (e) => {                        
                        e.stopPropagation()
                    }
                }
            },[checkboxVNode]);

            // clicking title toggles selection (for product lines, cascades to children)
            let titleClick = (e) => {                
                this.toggleNode(node, data, e)
            };
            if (data.isMachine) {
                checkboxVNode = h('input', {
                    key: `cb-m-${data.id}`,
                    attrs: { type: 'checkbox' ,id: 'cb-m-'+data.id,'data-pl-id': data.pl_id},
                    domProps: { checked: data.selected },
                    style: { marginRight: '0px', cursor: 'pointer', width: '16px', height: '16px' },
                    on: {
                        change: (e) => this.onNodeCheckboxChange(data, e.target.checked),
                        click: (e) => e.stopPropagation()
                    }
                });
                Label = h('label', {
                style: { display:'inline-block',paddingRight:'8px', },
                attrs: { for: 'cb-m-'+data.id },
                on: {
                    click: (e) => {                        
                        e.stopPropagation()
                    }
                }
            },[checkboxVNode]);
                titleClick = (e) => {
                    this.onNodeCheckboxChange(data, !data.selected);
                    e.stopPropagation()
                }
            }

            // NEW: arrow icon after Label for non-machine nodes with children
            const hasChildren = !data.isMachine && Array.isArray(data.children) && data.children.length > 0;
            const isOpen = hasChildren && (data.expand === true || node.expand === true);
            const arrowVNode = hasChildren
                ? h('Icon', {
                    props: { type: isOpen ? 'md-arrow-dropdown' : 'md-arrow-dropright', size: 14 },
                    style: { marginRight: '0px', cursor: 'pointer', color: '#606266' },
                    on: {
                        click: (e) => {
                            e.stopPropagation();
                            this.toggleNode(node, data, e);
                        }
                    }
                })
                : null;

            return h('span', {
                style: { display: 'inline-block', width: '100%' },
                class: { 'tree-item': true, 'is-selected': data.selected === true },
                on: {
                    click: (e) => {                        
                        e.stopPropagation()
                    }
                }
            }, [
                h('span', { style: { cursor: 'pointer', display: 'inline-flex', alignItems: 'top' } }, [
                    Label,
                    arrowVNode,
                    h('span', { on: { click: titleClick }, attrs:{class:"break-word"} }, title)
                ]),
            ]);
        },

        // recursively collect selected ids from the tree
        updateSelectedMacIds() {          
            const ids = [];
            const walk = (nodes) => {
                (nodes || []).forEach(n => {
                    if (n.isMachine && n.selected && n.id != null) ids.push(n.id);
                    if (Array.isArray(n.children) && n.children.length) walk(n.children);
                });
            };
            walk(this.macData || []);
            this.$emit('updateSelectedMacIds', ids);
        },

        // checkbox change handler (supports cascade)
        onMacNodeCheckboxChange(data, val) {
            this.$set(data, 'selected', val);
            if (!data.isMachine) {
                this.setChildrenSelection(data, val);
            }
            this.updateSelectedMacIds();
        },

        toggleNode(node, data, e) {
            if (e) e.stopPropagation();
            if (data && Array.isArray(data.children) && data.children.length) {
                const next = !(data.expand === true);
                this.$set(data, 'expand', next);
                if (node && typeof node.expand !== 'undefined') node.expand = next;
            }
        },

        setChildrenSelection(data, val) {            
            // operate on data.children and ensure reactivity on each child
            (data.children || []).forEach(c => {
                this.$set(c, 'selected', val);
            });            
            this.selectionVersion += 1; // force re-render
        },

        toggleMacNodeSelection(data) {
            const next = !data.selected;
            this.$set(data, 'selected', next);
            this.selectionVersion += 1; // force re-render
            this.updateSelectedMacIds();
        },

        onNodeCheckboxChange(data, val) {
            this.$set(data, 'selected', val);
            this.updateSelectedMacIds();            
        },
        checkAll() {            
            this.allCheck = !this.allCheck;
            this.selectionVersion += 1; // force re-render
            this.macData.forEach(item => {
                item.selected = this.allCheck;
                this.$set(item, 'selected', this.allCheck);
                if (Array.isArray(item.children)) {
                    item.children.forEach(c => {
                        this.$set(c, 'selected', this.allCheck);
                    });
                }   
            });
            this.updateSelectedMacIds();
        }

    },
}
</script>
<style>
.break-word {
      overflow: hidden;
    word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
}

/* Hide default tree arrow to use custom one */
.tree-render .ivu-tree-arrow {
    display: none;
}

.all-check{
    cursor: pointer;
    border: 1px solid #fff;
    width: 16px;
    height: 16px;
    outline: none;
    box-shadow: none;
    background: transparent;
    padding: 6px 2px;
    opacity: 1;
    font-size: 14px;
}
</style>

<style scoped>
@import url("../../../assets/style/list.css");
@import url("../../../assets/style/tab.css");


</style>